export function formatScore(val, fmt) {
  if (val === null || val === undefined) return ''
  const s = String(val).trim()
  if (s === '') return ''
  if (!/^-?\d+(\.\d+)?$/.test(s)) return s

  const f = fmt === undefined || fmt === null ? '' : String(fmt)
  if (f === '5' || f === '') return s

  const round = f === '1' || f === '3'
  const digits = f === '1' || f === '2' ? 2 : 3

  if (round) {
    return Number(s).toFixed(digits)
  }

  const parts = s.split('.')
  const intPart = parts[0]
  const decPart = (parts[1] || '').padEnd(digits, '0').slice(0, digits)
  return digits === 0 ? intPart : `${intPart}.${decPart}`
}
